export default __webpack_public_path__ + "static/media/password-restored.b410dfbd.svg";